import { ref, onMounted, onUnmounted } from "vue";

export function useActiveTimer(inactivityLimit = 30000) {
	const seconds = ref(0);
	let startTime = null;
	let elapsed = 0;
	let running = false;
	let inactivityTimeout = null;
	
	const start = () => {
		stop();
		elapsed = 0;
		startTime = Date.now();
		running = true;
		resetInactivityTimer();
	};
	
	const stop = () => {
		if (running) {
			elapsed += Date.now() - startTime;
		}
		running = false;
		clearTimeout(inactivityTimeout);
	};
	
	const resume = () => {
		if (!running) {
			startTime = Date.now();
			running = true;
			resetInactivityTimer();
		}
	};
	
	const getSeconds = () => {
		let total = elapsed;
		if (running) {
			total += Date.now() - startTime;
		}
		return Math.floor(total / 1000);
	};
	
	const pause = () => {
		if (!running) return;
		elapsed += Date.now() - startTime;
		running = false;
		clearTimeout(inactivityTimeout);
	};
	
	const resetInactivityTimer = () => {
		clearTimeout(inactivityTimeout);
		inactivityTimeout = setTimeout(pause, inactivityLimit);
	};
	
	const handleActivity = () => {
		if (!document.hidden) {
			if (!running) resume();
			resetInactivityTimer();
		}
	};
	
	const handleVisibility = () => {
		if (document.hidden) pause();
		else resume();
	};
	
	onMounted(() => {
		["mousemove", "keydown", "click", "scroll"].forEach(event =>
			window.addEventListener(event, handleActivity)
		);
		document.addEventListener("visibilitychange", handleVisibility);
	});
	
	onUnmounted(() => {
		["mousemove", "keydown", "click", "scroll"].forEach(event =>
			window.removeEventListener(event, handleActivity)
		);
		document.removeEventListener("visibilitychange", handleVisibility);
		clearTimeout(inactivityTimeout);
	});
	
	setInterval(() => {
		seconds.value = getSeconds();
	}, 1000);
	
	return { seconds, start, stop, resume };
}